(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5285],{

/***/ 26185:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/voucher-redemption",
      function () {
        return __webpack_require__(28189);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 89183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _public_icons_shared_logo_share_og_png__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34841);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_3__);




/**
 * It's a function that takes in a bunch of props and returns a bunch of meta tags.
 * @param  - FC<SeoProps> = ({
 * @returns A React component.
 */ var Seo = function(param) {
    var description = param.description, title = param.title, image = param.image, pagePath = param.pagePath, canonical = param.canonical, noIndex = param.noIndex, noFollow = param.noFollow, components = param.components;
    var publicRuntimeConfig = next_config__WEBPACK_IMPORTED_MODULE_3___default()().publicRuntimeConfig;
    var nextPublicBaseUrl = publicRuntimeConfig.nextPublicBaseUrl;
    var handleCanonicalUrl = function(url) {
        return url.split(/[?#]/)[0];
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1.0"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: handleCanonicalUrl(canonical || pagePath === "/" ? "" : "".concat(nextPublicBaseUrl).concat(pagePath))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                href: handleCanonicalUrl("".concat(nextPublicBaseUrl, "en").concat(pagePath === null || pagePath === void 0 ? void 0 : pagePath.slice(2))),
                hrefLang: "en"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                href: handleCanonicalUrl("".concat(nextPublicBaseUrl, "en").concat(pagePath === null || pagePath === void 0 ? void 0 : pagePath.slice(2))),
                hrefLang: "x-default"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                href: handleCanonicalUrl("".concat(nextPublicBaseUrl, "ar").concat(pagePath === null || pagePath === void 0 ? void 0 : pagePath.slice(2))),
                hrefLang: "ar"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "image",
                content: image ? image : "".concat(nextPublicBaseUrl).concat(_public_icons_shared_logo_share_og_png__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src.slice */ .Z.src.slice(1))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "image:width",
                content: "250"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "image:height",
                content: "250"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image ? image : "".concat(nextPublicBaseUrl).concat(_public_icons_shared_logo_share_og_png__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src.slice */ .Z.src.slice(1))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:width",
                content: "250"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:height",
                content: "250"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: "".concat(nextPublicBaseUrl).concat(pagePath === "/" ? "" : pagePath)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "article"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: "muvi Cinemas"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:site",
                content: "@muvicinemas"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:creator",
                content: "@muvicinemas"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: image ? image : "".concat(nextPublicBaseUrl).concat(_public_icons_shared_logo_share_og_png__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src.slice */ .Z.src.slice(1))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:image:width",
                content: "250"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:image:height",
                content: "250"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:url",
                content: "".concat(nextPublicBaseUrl).concat(pagePath === "/" ? "" : pagePath)
            }),
            (noIndex || noFollow) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: noIndex && noFollow ? "noindex,nofollow" : noIndex ? "noindex" : "nofollow"
            }),
            !!components && components()
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Seo);


/***/ }),

/***/ 71192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ LottiePlayer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36822);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);



var Lottie = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(296), __webpack_require__.e(9260)]).then(__webpack_require__.t.bind(__webpack_require__, 69260, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69260)
            ];
        }
    },
    ssr: false
});
var LottiePlayer = function(param) {
    var boxSx = param.boxSx, animationData = param.animationData;
    return animationData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        sx: boxSx,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Lottie, {
            animationData: animationData,
            loop: true
        })
    });
};


/***/ }),

/***/ 75884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ MovieLoaderWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(36822);
// EXTERNAL MODULE: ./src/components/shared/lottie-player.tsx
var lottie_player = __webpack_require__(71192);
;// CONCATENATED MODULE: ./src/lotties/movieLoader.json
var movieLoader_namespaceObject = JSON.parse('{"nm":"Comp 1","mn":"","layers":[{"ty":3,"nm":"Null 1","mn":"","sr":1,"st":0,"op":120,"ip":0,"hd":false,"cl":"","ln":"","ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[960,540,0],"ix":2},"sa":{"a":0,"k":0},"o":{"a":0,"k":0,"ix":11},"r":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.294,"y":1},"s":[0],"t":0},{"o":{"x":0.655,"y":0},"i":{"x":0.667,"y":1},"s":[360],"t":60},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[720],"t":117.5}],"ix":10}},"ef":[],"ind":1},{"ty":4,"nm":"Ellipse 4","mn":"","sr":1,"st":0,"op":120,"ip":0,"hd":false,"cl":"","ln":"","ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0,0,0],"t":0},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[-134,134,0],"t":60},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0,0,0],"t":117.5}],"ix":2},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[80],"t":0},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":60},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[80],"t":117.5}],"ix":11},"r":{"a":0,"k":0,"ix":10}},"ef":[],"shapes":[{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 4 Stroke","ix":1,"cix":2,"np":3,"it":[{"ty":"el","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[118,118],"ix":2}},{"ty":"op","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Filter - Offset","nm":"Offset Paths 1","ix":3,"a":{"a":0,"k":-0.5,"ix":1},"lj":1,"ml":{"a":0,"k":4,"ix":3}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]},{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 4 Fill","ix":2,"cix":2,"np":2,"it":[{"ty":"el","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[118,118],"ix":2}},{"ty":"fl","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.8196,0.6667,0.8431],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":2,"parent":1},{"ty":4,"nm":"Ellipse 3","mn":"","sr":1,"st":0,"op":120,"ip":0,"hd":false,"cl":"","ln":"","ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0,0,0],"t":0},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[134,134,0],"t":60},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0,0,0],"t":117.5}],"ix":2},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[80],"t":0},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":60},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[80],"t":117.5}],"ix":11},"r":{"a":0,"k":0,"ix":10}},"ef":[],"shapes":[{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 3 Stroke","ix":1,"cix":2,"np":3,"it":[{"ty":"el","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[118,118],"ix":2}},{"ty":"op","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Filter - Offset","nm":"Offset Paths 1","ix":3,"a":{"a":0,"k":-0.5,"ix":1},"lj":1,"ml":{"a":0,"k":4,"ix":3}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]},{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 3 Fill","ix":2,"cix":2,"np":2,"it":[{"ty":"el","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[118,118],"ix":2}},{"ty":"fl","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.549,0.1725,0.6078],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":3,"parent":1},{"ty":4,"nm":"Ellipse 2","mn":"","sr":1,"st":0,"op":120,"ip":0,"hd":false,"cl":"","ln":"","ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0,0,0],"t":0},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[134,-134,0],"t":60},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0,0,0],"t":117.5}],"ix":2},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[80],"t":0},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":60},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[80],"t":117.5}],"ix":11},"r":{"a":0,"k":0,"ix":10}},"ef":[],"shapes":[{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 2 Stroke","ix":1,"cix":2,"np":3,"it":[{"ty":"el","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[118,118],"ix":2}},{"ty":"op","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Filter - Offset","nm":"Offset Paths 1","ix":3,"a":{"a":0,"k":-0.5,"ix":1},"lj":1,"ml":{"a":0,"k":4,"ix":3}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]},{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 2 Fill","ix":2,"cix":2,"np":2,"it":[{"ty":"el","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[118,118],"ix":2}},{"ty":"fl","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.7333,0.502,0.7686],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":4,"parent":1},{"ty":4,"nm":"Ellipse 1","mn":"","sr":1,"st":0,"op":120,"ip":0,"hd":false,"cl":"","ln":"","ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0,0,0],"t":0},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[-134,-134,0],"t":60},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0,0,0],"t":117.5}],"ix":2},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.188,"y":1},"s":[80],"t":0},{"o":{"x":0.899,"y":-0.919},"i":{"x":0.667,"y":1},"s":[100],"t":60},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[80],"t":117.5}],"ix":11},"r":{"a":0,"k":0,"ix":10}},"ef":[],"shapes":[{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 1 Stroke","ix":1,"cix":2,"np":3,"it":[{"ty":"el","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[118,118],"ix":2}},{"ty":"op","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Filter - Offset","nm":"Offset Paths 1","ix":3,"a":{"a":0,"k":-0.5,"ix":1},"lj":1,"ml":{"a":0,"k":4,"ix":3}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]},{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 1 Fill","ix":2,"cix":2,"np":2,"it":[{"ty":"el","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[118,118],"ix":2}},{"ty":"fl","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.549,0.1725,0.6078],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":5,"parent":1}],"ddd":0,"h":1080,"w":1920,"meta":{"a":"","k":"","d":"","g":"LottieFiles AE 1.1.0","tc":"#000000"},"v":"4.8.0","fr":60,"op":120,"ip":0,"assets":[]}');
;// CONCATENATED MODULE: ./src/components/shared/movie-loader-wrapper.tsx




var MovieLoaderWrapper = function(param) {
    var innerBox = param.innerBox, outerBox = param.outerBox;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: outerBox,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lottie_player/* LottiePlayer */.V, {
            animationData: movieLoader_namespaceObject,
            boxSx: innerBox
        })
    });
};


/***/ }),

/***/ 33224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ SeoPagesEnum; }
/* harmony export */ });
var SeoPagesEnum;
(function(SeoPagesEnum) {
    SeoPagesEnum["termsAndCondition"] = "TERMS_CONDITIONS";
    SeoPagesEnum["privacyPolicy"] = "PRIVACY_POLICY";
    SeoPagesEnum["contactUs"] = "CONTACT_US";
    SeoPagesEnum["aboutUs"] = "ABOUT_US";
    SeoPagesEnum["vouchersHowTo"] = "VOUCHERS_HOW_TO";
    SeoPagesEnum["privateBooking"] = "PRIVATE_BOOKINGS";
    SeoPagesEnum["foodMenu"] = "FOOD_MENU";
    SeoPagesEnum["offers"] = "OFFERS";
    SeoPagesEnum["cinemas"] = "CINEMAS";
    SeoPagesEnum["experiences"] = "EXPERIENCES";
    SeoPagesEnum["finder"] = "FINDER";
    SeoPagesEnum["home"] = "HOME";
})(SeoPagesEnum || (SeoPagesEnum = {}));


/***/ }),

/***/ 36575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ findSeoInsidePage; }
/* harmony export */ });
/**
 * It takes an array of PageMetaDataModel objects and a pageEnum string and returns the
 * PageMetaDataModel object that matches the pageEnum string
 * @param {PageMetaDataModel[]} array - PageMetaDataModel[] - this is the array of objects that we are
 * searching through.
 * @param {string} pageEnum - This is the page enum that you want to find the SEO data for.
 * @returns the first item in the array that matches the pageEnum.
 */ function findSeoInsidePage(array, pageEnum) {
    return array === null || array === void 0 ? void 0 : array.find(function(item) {
        return item.page === pageEnum;
    });
}


/***/ }),

/***/ 97016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* reexport */ useGetPagesSeoMeta; }
});

// EXTERNAL MODULE: ./src/logic/libs/index.ts
var libs = __webpack_require__(81900);
// EXTERNAL MODULE: ./src/constants/cashing.ts
var cashing = __webpack_require__(29236);
;// CONCATENATED MODULE: ./src/logic/services/seo/services.ts


var url = "page-meta-data";
var useGetPagesSeoMeta = (0,libs/* createQuery */.rP)({
    url: "".concat(url),
    method: "get"
}, {
    staleTime: cashing/* long_term_cashing */.d
});

;// CONCATENATED MODULE: ./src/logic/services/seo/index.ts




/***/ }),

/***/ 28189:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(36822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(76624);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(44472);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(83578);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86896);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(44012);
/* harmony import */ var _logic_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10029);
/* harmony import */ var _components_seo_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89183);
/* harmony import */ var _constants_seo_pages_enum__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33224);
/* harmony import */ var _logic_helpers_find_seo_inside_page__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36575);
/* harmony import */ var _theme_typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43795);
/* harmony import */ var _logic_services_seo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97016);
/* harmony import */ var _components_shared_image_box_future__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58718);
/* harmony import */ var _components_shared_movie_loader_wrapper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75884);












var VoucherRedemption = function(param) {
    var path = param.path;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (0,_logic_services_seo__WEBPACK_IMPORTED_MODULE_5__/* .useGetPagesSeoMeta */ ._)(), seoDataList = ref6.data;
    var seoPage = (0,_logic_helpers_find_seo_inside_page__WEBPACK_IMPORTED_MODULE_8__/* .findSeoInsidePage */ .W)(seoDataList === null || seoDataList === void 0 ? void 0 : seoDataList.pageMetaData, _constants_seo_pages_enum__WEBPACK_IMPORTED_MODULE_3__/* .SeoPagesEnum.vouchersHowTo */ .E.vouchersHowTo);
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)();
    var ref7 = (0,_logic_services__WEBPACK_IMPORTED_MODULE_1__/* .useGetVoucherRedemptionSteps */ .z1)({}), voucherRedemptionSteps = ref7.data, isLoading = ref7.isLoading;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)();
    var ref8 = (0,_logic_services__WEBPACK_IMPORTED_MODULE_1__/* .useGetSettings */ .Y4)(), allCmsSetting = ref8.data;
    var _obj, _obj1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_seo_seo__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: (seoPage === null || seoPage === void 0 ? void 0 : seoPage.titleTag) || intl.formatMessage({
                    id: "voucher_redemption"
                }),
                canonical: seoPage === null || seoPage === void 0 ? void 0 : seoPage.canonicalURL,
                pagePath: path,
                description: (seoPage === null || seoPage === void 0 ? void 0 : seoPage.descriptionTag) || (allCmsSetting === null || allCmsSetting === void 0 ? void 0 : allCmsSetting.voucherRedemptionDescription),
                noFollow: seoPage === null || seoPage === void 0 ? void 0 : seoPage.hasFollow,
                noIndex: seoPage === null || seoPage === void 0 ? void 0 : seoPage.hasIndex
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                component: "section",
                sx: {
                    flexGrow: 1,
                    px: {
                        laptop: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(128),
                        tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(40),
                        mobile: "16px"
                    },
                    mb: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(122)
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        component: "h1",
                        sx: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                            fontSize: {
                                tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(30),
                                mobile: "18px"
                            },
                            color: theme.palette.grey[80],
                            my: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(52),
                            fontWeight: 700
                        }, theme.breakpoints.down("tablet"), {
                            mt: "32px",
                            mb: "24px"
                        }),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            id: "voucher_redemption"
                        })
                    }),
                    !isLoading ? voucherRedemptionSteps.voucherRedemptionSteps.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        sx: {
                            maxWidth: "1102px",
                            mx: "auto",
                            background: theme.palette.layout.bgSecondary,
                            borderRadius: "25px",
                            px: {
                                tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(140),
                                mobile: "16px"
                            },
                            pt: {
                                tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(32),
                                mobile: "16px"
                            },
                            pb: {
                                tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(43),
                                mobile: "24px"
                            }
                        },
                        children: [
                            (allCmsSetting === null || allCmsSetting === void 0 ? void 0 : allCmsSetting.voucherRedemptionDescription) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                component: "p",
                                sx: {
                                    color: theme.palette.grey[70],
                                    fontSize: {
                                        tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(24),
                                        mobile: "16px"
                                    },
                                    mb: {
                                        tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(40),
                                        mobile: "24px"
                                    },
                                    whiteSpace: "pre-line"
                                },
                                children: allCmsSetting.voucherRedemptionDescription
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                orientation: "vertical",
                                sx: {
                                    "& .MuiStepConnector-root ": {
                                        transform: {
                                            tablet: "scaleY(2.3)",
                                            mobile: "scaleY(5)"
                                        },
                                        mx: {
                                            tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(20),
                                            mobile: "15px"
                                        },
                                        height: {
                                            tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(47),
                                            mobile: "52px"
                                        },
                                        "& .MuiStepConnector-line": {
                                            height: {
                                                tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(47),
                                                mobile: "52px"
                                            }
                                        }
                                    },
                                    "&  .MuiStepConnector-root:nth-of-type(2)": (_obj = {
                                        background: "transparent"
                                    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, theme.breakpoints.down("tablet"), {
                                        transform: "scaleY(5) translateY(20%)"
                                    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, theme.breakpoints.down(425), {
                                        transform: " ".concat(((ref = voucherRedemptionSteps === null || voucherRedemptionSteps === void 0 ? void 0 : voucherRedemptionSteps.voucherRedemptionSteps[0]) === null || ref === void 0 ? void 0 : ref.desc.length) < 80 ? " scaleY(5) translateY(20%)" : ((ref1 = voucherRedemptionSteps === null || voucherRedemptionSteps === void 0 ? void 0 : voucherRedemptionSteps.voucherRedemptionSteps[0]) === null || ref1 === void 0 ? void 0 : ref1.desc.length) < 100 ? "scaleY(3) translateY( 10%)" : "scaleY(4.5) translateY( 10%) ", " ")
                                    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, theme.breakpoints.down(370), {
                                        transform: " ".concat(((ref2 = voucherRedemptionSteps === null || voucherRedemptionSteps === void 0 ? void 0 : voucherRedemptionSteps.voucherRedemptionSteps[0]) === null || ref2 === void 0 ? void 0 : ref2.desc.length) < 80 ? " scaleY(5) translateY(20%)" : ((ref3 = voucherRedemptionSteps === null || voucherRedemptionSteps === void 0 ? void 0 : voucherRedemptionSteps.voucherRedemptionSteps[0]) === null || ref3 === void 0 ? void 0 : ref3.desc.length) < 100 ? "scaleY(5) translateY( 10%)" : ((ref4 = voucherRedemptionSteps === null || voucherRedemptionSteps === void 0 ? void 0 : voucherRedemptionSteps.voucherRedemptionSteps[0]) === null || ref4 === void 0 ? void 0 : ref4.desc.length) < 125 ? "scaleY(4.5) translateY( 10%)" : "scaleY(5.7) translateY( 0%)", " ")
                                    }), _obj),
                                    "&  .MuiStepConnector-root:nth-last-of-type(2)": (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj1, theme.breakpoints.down("tablet"), {
                                        transform: "scaleY(5) translateY(-20%)"
                                    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj1, theme.breakpoints.down(380), {
                                        transform: "scaleY(5) translateY(-20%)"
                                    }), _obj1),
                                    "& .MuiStepConnector-line": {
                                        borderColor: "#D1AAD7",
                                        borderLeftWidth: "3px"
                                    },
                                    "& .MuiStepLabel-iconContainer": {
                                        padding: 0,
                                        outline: "7px solid ".concat(theme.palette.layout.backgroundColor),
                                        borderRadius: "100%"
                                    },
                                    "& .MuiStep-root ": {
                                        position: "relative",
                                        zIndex: 10
                                    },
                                    ".MuiStepConnector-line": {
                                        animation: "opacityBorder 2000ms ".concat(theme.transitions.easing.easeInOut, " both "),
                                        animationDelay: "1.2s",
                                        "@keyframes opacityBorder": {
                                            "0%": {
                                                opacity: 0
                                            },
                                            "100%": {
                                                opacity: 1
                                            }
                                        }
                                    }
                                },
                                children: voucherRedemptionSteps === null || voucherRedemptionSteps === void 0 ? void 0 : (ref5 = voucherRedemptionSteps.voucherRedemptionSteps) === null || ref5 === void 0 ? void 0 : ref5.map(function(step, index) {
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        sx: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                                            animation: "translateBottom 1500ms ".concat(theme.transitions.easing.easeInOut, " both "),
                                            animationDelay: "".concat(index / 5, "s"),
                                            "@keyframes translateBottom": {
                                                "0%": {
                                                    opacity: 0,
                                                    transform: "translateY(+2000px)"
                                                },
                                                "100%": {
                                                    opacity: 1,
                                                    transform: "translateY(0)"
                                                }
                                            }
                                        }, theme.breakpoints.down("tablet"), {
                                            ".MuiStepLabel-label  > div.MuiBox-root": {
                                                alignItems: step.desc.length > 80 ? "stretch" : "center"
                                            },
                                            ".MuiStepLabel-root": {
                                                alignItems: step.desc.length > 80 ? "baseline" : "center"
                                            }
                                        }),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                            sx: {
                                                display: "flex",
                                                "& .MuiSvgIcon-root": {
                                                    width: {
                                                        tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(42),
                                                        mobile: "31px"
                                                    },
                                                    height: {
                                                        tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(42),
                                                        mobile: "31px"
                                                    },
                                                    color: theme.palette.primary.main,
                                                    borderRadius: "100%"
                                                },
                                                "& .MuiStepIcon-text": {
                                                    fontSize: {
                                                        tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(22),
                                                        mobile: "16px"
                                                    }
                                                }
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                component: "article",
                                                sx: {
                                                    display: "flex",
                                                    alignItems: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_image_box_future__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                        img: step === null || step === void 0 ? void 0 : step.icon,
                                                        title: intl.formatMessage({
                                                            id: "voucher.step_icon"
                                                        }),
                                                        objectFit: "contain",
                                                        sx: {
                                                            minWidth: {
                                                                tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(94),
                                                                mobile: "80px"
                                                            },
                                                            height: {
                                                                tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(94),
                                                                mobile: "80px"
                                                            },
                                                            mx: {
                                                                tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(40),
                                                                mobile: "16px"
                                                            },
                                                            overflow: "hidden"
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                        component: "p",
                                                        sx: {
                                                            fontSize: {
                                                                tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(18),
                                                                mobile: "14px"
                                                            },
                                                            color: theme.palette.grey[70],
                                                            lineHeight: " 150%"
                                                        },
                                                        children: step.desc
                                                    })
                                                ]
                                            })
                                        })
                                    }, step.id);
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        component: "div",
                        sx: {
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            position: "relative",
                            pt: {
                                tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(37),
                                mobile: "26px"
                            },
                            mb: {
                                tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(32),
                                mobile: "24px"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_image_box_future__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                img: "/icons/profile/credit-card/credit-cards-empty.svg",
                                title: intl.formatMessage({
                                    id: "voucher_redemption.no_steps"
                                }),
                                objectFit: "contain",
                                sx: {
                                    mb: {
                                        tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(24),
                                        mobile: "24px"
                                    },
                                    maxWidth: "100%",
                                    width: {
                                        tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(250),
                                        mobile: "200px"
                                    },
                                    height: {
                                        tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(182),
                                        mobile: "145px"
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                component: "p",
                                sx: {
                                    fontSize: {
                                        tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(20),
                                        mobile: "16px"
                                    },
                                    textAlign: "center",
                                    color: theme.palette.grey[50],
                                    maxWidth: {
                                        tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(461),
                                        mobile: "461px"
                                    },
                                    lineHeight: "150%"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                    id: "voucher_redemption.no_steps"
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_movie_loader_wrapper__WEBPACK_IMPORTED_MODULE_7__/* .MovieLoaderWrapper */ .Y, {
                        innerBox: {
                            width: "200px",
                            height: "200px"
                        },
                        outerBox: {
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            minHeight: "40vh"
                        }
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (VoucherRedemption);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9172,9774,2888,179], function() { return __webpack_exec__(26185); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);